import {ConfigurationGroupNode} from "#pricing/nodes/configuration-group-node"
import type {FlattenPriceList} from "#pricing/nodes/flatten-pricelist"
import {PriceList} from "#pricing/nodes/price-list"
import {PricedItemNode} from "#pricing/nodes/priced-item-node"
import {VariantConditionNode} from "#pricing/nodes/variant-condition-node"

export function checkConfigurationGroupNodes(rootNode: FlattenPriceList) {
    const configurationGroupNodes = rootNode.getNodesOfType(ConfigurationGroupNode)
    const configurationGroupNodeIds = new Set(configurationGroupNodes.map((node) => node.getGroupId()))
    if (configurationGroupNodeIds.size !== configurationGroupNodes.length) {
        const duplicateIds = configurationGroupNodes.map((node) => node.getGroupId()).filter((id, index, self) => self.indexOf(id) !== index)
        throw new Error("Duplicate configuration group node ids: " + duplicateIds.join(", "))
    }

    const pricedItemNodes = rootNode.getNodesOfType(PricedItemNode)
    for (const pricedItemNode of pricedItemNodes) {
        pricedItemNode.getVariantIds().forEach((condition) => {
            let configGroupParentFound = false

            const conditionNode = pricedItemNode.parameters.condition
            const configList = conditionNode instanceof VariantConditionNode ? (conditionNode.parameters.currentConfigurations?.parameters.list ?? []) : []
            for (const configurationGroupNode of configList) {
                if (configurationGroupNode.hasVariant(condition)) {
                    configGroupParentFound = true
                    break
                }
            }

            if (!configGroupParentFound) throw new Error("Priced item node has condition that is not a variant of any of its configuration group parents")
        })
    }
}

export function checkMutuallyExclusiveConditions(rootNode: FlattenPriceList) {
    const subPriceNodes = rootNode.getNodesOfType(PriceList)
    for (const subPriceNode of subPriceNodes) if (!subPriceNode.mutuallyExclusive()) throw new Error("Price list node has non mutually exclusive conditions")
}
